import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Methodology from "@/pages/Methodology";
import Dashboard from "@/pages/Dashboard";
import Today from "@/pages/Today";
import Markets from "@/pages/Markets";
import MarketDetail from "@/pages/MarketDetail";
import Traders from "@/pages/Traders";
import TraderDetail from "@/pages/TraderDetail";
import Signals from "@/pages/Signals";
import SignalDetail from "@/pages/SignalDetail";
import Watchlists from "@/pages/Watchlists";
import Alerts from "@/pages/Alerts";
import Admin from "@/pages/Admin";
import Timeline from "@/pages/Timeline";
import Overlap from "@/pages/Overlap";
import History from "@/pages/History";
import Chat from "@/pages/Chat";
import Account from "@/pages/Account";
import DemoLogin from "@/pages/DemoLogin";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TooltipProvider delayDuration={120} skipDelayDuration={300}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/demo" element={<DemoLogin />} />

          <Route path="/app" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="today" element={<Today />} />
            <Route path="timeline" element={<Timeline />} />
            <Route path="overlap" element={<Overlap />} />
            <Route path="signals" element={<Signals />} />
            <Route path="signals/:id" element={<SignalDetail />} />
            <Route path="markets" element={<Markets />} />
            <Route path="markets/:id" element={<MarketDetail />} />
            <Route path="traders" element={<Traders />} />
            <Route path="traders/:id" element={<TraderDetail />} />
            <Route path="watchlists" element={<Watchlists />} />
            <Route path="history" element={<History />} />
            <Route path="chat" element={<Chat />} />
            <Route path="alerts" element={<Alerts />} />
            <Route path="account" element={<Account />} />
            <Route path="methodology" element={<Methodology />} />
            <Route
              path="admin"
              element={
                <ProtectedRoute adminOnly>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
        </TooltipProvider>
      </AuthProvider>
      <Toaster theme="dark" />
    </BrowserRouter>
  );
}

export default App;
